export default "__VITE_ASSET__OPHUo3S1__"